export const GET_LESSONS_LIST = 'GET_LESSONS_LIST'
export const GET_JOURNAL = 'GET_JOURNAL'
export const GET_FILTER_STUDY_GROUPS = 'GET_FILTER_STUDY_GROUPS'
export const GET_FILTER_DISCIPLINES = 'GET_FILTER_DISCIPLINES'
export const CLEAR_JOURNAL = 'CLEAR_JOURNAL'
export const SET_IS_BUSY = 'SET_IS_BUSY'
export const SET_ITEM_IS_UPDATING = 'SET_ITEM_IS_UPDATING'
